import { _APP_STORE } from '@/core/values/app.values';
import {COURSE_EVENTS} from '@/content/values/events';
import Component from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import EdMaterialViewer from '@/courses/components/ed-material-viewer/ed-material-viewer.vue';
import EdSplitTabs from '@/courses/components/ed-split-tabs/ed-split-tabs.vue';
import EdSplitVertical from '@/courses/components/ed-split-vertical/ed-split-vertical.vue';
import EdSplitHorizontal from '@/courses/components/ed-split-horizontal/ed-split-horizontal.vue';
import { IparamsSplitTabs } from '@/courses/interfaces/params-split-tabs.interface';
import { IparamsSplitOrientation } from '@/courses/interfaces/params-split-orientation.interface';
import { CourseViewerSplitObjectMixin } from '@/courses/mixins/course-viewer-split-object.mixin';
import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';

@Component({
  components: {
    EdMaterialViewer,
    EdSplitTabs,
    EdSplitVertical,
    EdSplitHorizontal 
  }
})
export default class EdViewerWriteObject extends Mixins(CourseViewerSplitObjectMixin, ScreenMirroringMixin) {

  loaded: boolean = false;

  /* Computed */
  get answerUrl(): string {
    return this.answer ? this.answer.assetsInfo[0].url : null;
  }

  get hasSplits(): boolean {
    if(this.isTeacher) {
      return this.hasAnswer;
    } else {
      return (this.answer || this.response) && !this.isScreenMirroringActive ? true : false;
    }
  }

  get splitTabsParams(): IparamsSplitTabs {
    return {
      contentsId: this.contentsId,
      hasSplits: this.hasSplits,
      oneviewSelected: this.oneviewSelected,
      tabSelected: this.tabSelected 
    }
  }

  get splitOrientationParams(): IparamsSplitOrientation{
    return {
      menuSplitFirst: this.menuSplitFirst ,
      menuSplitSecond : this.menuSplitSecond ,
      answer: this.answer , isTeacher: this.isTeacher ,
      response: this.response
    }
  }

  get answerDocumentIndex():number {
    //answerDocumentIndex (a.k.a. index for document used as whiteboard background)
    //if problem is multimedia then answer must be a template instead of problem.
    return this.problemMaterial?.isMultimediaFile ? 0 : 1;
  }


  /* Watchers */
  @Watch('userModeForScreenMirroring', { immediate: false, deep: true })
  reloadScreenMirroring() {
    this.setTab(this.hasSplits ? this.contentsId.splitHorizontal : this.contentsId.problem);
  }

  /* Methods */
  setTab(contentId: string) {

    if( this.isScreenMirroringBookModeActive ) {
      this.settingTab({
        contentId: this.contentsId.problem,
        el: this.$refs.EdViewerWriteObjectTabs,
        response: this.response
      });
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.problem );
      });

    } else if( this.isScreenMirroringPaperModeActive ) {
      if( this.answer ) {
        this.settingTab({
          contentId: this.contentsId.answer,
          el: this.$refs.EdViewerWriteObjectTabs,
          response: this.response
        });
        this.menu.forEach(m => {
          m.visible = ( m.contentId === this.contentsId.answer );
        });
      }

      if( this.response ) {
        this.settingTab({
          contentId: this.contentsId.response,
          el: this.$refs.EdViewerWriteObjectTabs,
          response: this.response
        });
        this.menu.forEach(m => {
          m.visible = ( m.contentId === this.contentsId.response );
        });
      }

    } else {
      this.settingTab({
        contentId: contentId,
        el: this.$refs.EdViewerWriteObjectTabs,
        response: this.response
      });
    }
  }

  setObjectFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
  }

  /* Hooks */
  created() {
    this.setFiles();
    this.setMenu(this.response, this.hasAnswer);
    this.setMenuSplit(this.response);
    this.$edEventBus.$on(COURSE_EVENTS.SET_OBJECT_FULL_SCREEN, this.setObjectFullScreen);
  }
  
  mounted() {
    if(this.isTeacher) {
      if(this.answer) this.setTab(this.contentsId.splitHorizontal);
    } else if(this.answer || this.response) {
      this.setTab(this.contentsId.splitHorizontal);
    }
  }

  destroy() {
    this.$edEventBus.$off(COURSE_EVENTS.SET_OBJECT_FULL_SCREEN, this.setObjectFullScreen);
  }

}
